import baseTheme from '../baseTheme';
export var MuiMenu = {
    list: {
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: baseTheme.palette.grey[500],
    },
};
//# sourceMappingURL=MuiMenu.js.map